package com.futurions.portfolio.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

@Composable
fun AboutSection() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 60.px, bottom = 60.px)
            .justifyContent(JustifyContent.Center)
            .id("about"), // Important: for scroll linking,
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .maxWidth(900.px)
                .padding(32.px)
                .backgroundColor(rgba(255, 255, 255, 0.05))
                .backdropFilter(blur(16.px))
                .borderRadius(24.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 2.px,
                    blurRadius = 24.px,
                    spreadRadius = 8.px,
                    color = rgba(0, 0, 0, 0.3)
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // Heading
            SpanText(
                text = "🚀 About Me",
                modifier = Modifier
                    .fontSize(28.px)
                    .color(rgb(255, 255, 255))
                    .fontWeight(FontWeight.Bold)
                    .padding(bottom = 16.px)
            )



            // Short bio
            SpanText(
                text = "I’m a developer who loves building modern mobile apps using Kotlin Multiplatform, Jetpack Compose, Firebase, and custom REST APIs. I enjoy creating clean UI, improving user experience, and turning real ideas into apps that can go live on the Play Store.\n" +
                        "\n" +
                        "Along with app development, I’m also interested in game development and create gameplay systems, UI, and interactions using Unreal Engine (Blueprints) and Godot (GDScript).\n" +
                        "\n" +
                        "I use Figma for designing interfaces, build my own APIs when needed, and constantly explore new technologies to improve my work.",
                modifier = Modifier
                    .fontSize(17.px)
                    .lineHeight(28.px)
                    .color(rgb(220, 220, 220))
                    .textAlign(TextAlign.Center)
                    .maxWidth(700.px)
                    .padding(bottom = 40.px)
            )

            // Subheading
//            SpanText(
//                text = "🧰 Technologies & Tools",
//                modifier = Modifier
//                    .fontSize(22.px)
//                    .fontWeight(FontWeight.Medium)
//                    .color(rgb(255, 255, 255))
//                    .padding(bottom = 24.px)
//            )


            // Skills Grid
//            Row(
//                modifier = Modifier
//                    .fillMaxWidth()
//                    .justifyContent(JustifyContent.Center)
//                    .flexWrap(FlexWrap.Wrap)
//                    .gap(24.px)
//            ) {
//                SkillBadge("Kotlin")
//                SkillBadge("Kotlin Multiplatform")
//                SkillBadge("Jetpack Compose")
//                SkillBadge("Firebase")
//                SkillBadge("REST APIs")
//                SkillBadge("Unreal Engine (Blueprints)")
//                SkillBadge("Godot (GDScript)")
//                SkillBadge("Figma")
//                SkillBadge("GitHub")
//                SkillBadge("Room Database")
//            }
//
//            // Current Focus
//            SpanText(
//                text = "🔬 Currently exploring: AI & Robotics integration in mobile development",
//                modifier = Modifier
//                    .fontSize(17.px)
//                    .color(rgb(200, 200, 200))
//                    .textAlign(TextAlign.Center)
//                    .maxWidth(700.px)
//            )
        }
    }
}


@Composable
fun SkillBadge(skill: String) {
    Box(
        modifier = Modifier
            .padding(top = 8.px)
            .backgroundColor(rgba(255, 255, 255, 0.08))
            .borderRadius(16.px)
            .padding(topBottom = 10.px, leftRight = 20.px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 1.px,
                blurRadius = 12.px,
                color = rgba(0, 0, 0, 0.25)
            )
    ) {
        SpanText(
            text = skill,
            modifier = Modifier
                .fontSize(16.px)
                .color(rgb(230, 230, 230))
        )
    }
}
